import { render, staticRenderFns } from "./comp_ProductCard.vue?vue&type=template&id=3cb54120&scoped=true&"
import script from "./comp_ProductCard.vue?vue&type=script&lang=js&"
export * from "./comp_ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductCard.vue?vue&type=style&index=0&id=3cb54120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb54120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VSpacer})
